<template>
  <v-app-bar
    color="primary"
    :flat="!ui.toolbarElevation"
    :class="{
      'toolbar-up-position': ui.firstToolbarHide,
      'text-white': ui.darkMode !== true,
      'dark-bg': ui.darkMode === true
    }"
  >
    <!-- icon of navigation bar -->
    <v-app-bar-nav-icon
      v-show="!ui.leftDrawer"
      rounded="circle"
      @click="ui.leftDrawer = !ui.leftDrawer"
    />

    <!-- go-back button -->
    <v-btn
      v-if="!isHome"
      color="white"
      rounded="circle"
      size="large"
      icon="true"
      class="ml-3"
      @click="pushToBack()"
    >
      <v-icon icon="mdi-arrow-left" />
    </v-btn>

    <!-- title of navigation-->
    <v-toolbar-title
      class="font-weight-regular text-h5"
      :class="{'ml-10': isHome && ui.leftDrawer, 'ml-2': !isHome || !ui.leftDrawer}"
    >
      {{ $t($route.meta.title) }}
    </v-toolbar-title>
    <v-spacer />
  </v-app-bar>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['ui', 'location']),
      isHome () {
        return this.$route.name === 'Home' || this.$route.name === 'Any' || this.$route.name === 'HomePage'
      }
    },
    methods: {
      pushToBack: function () {
        if (this.$route.query.backurl) {
          // if back-url is in the query parameters, go back to that URL
          location.href = this.$route.query.backurl
        } else {
          if (this.location.backLink) {
            this.$router.push({ path: this.location.backLink })
            this.location.backLink = null
          } else {
            if (this.$route.meta.backLink) {
              this.$router.push({ name: this.$route.meta.backLink })
            } else {
              let path = this.$route.path
              let backDepth = 1
              if (this.$route.meta.backDepth) {
                backDepth = this.$route.meta.backDepth
              }
              for (let i = 0; i < backDepth; i++) {
                // remove the last segment of the path
                path = path.replace(/\/(?!.*\/).*/, '')
              }
              if (path === '') {
                path = '/'
              }
              this.$router.push({ path: path })
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  .toolbar-up-position {
    top: 0 !important;
  }

</style>
